import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useState, useRef, useEffect } from "react";

const EmojiPicker = ({ handleAddEmoji }) => {
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShow(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [show]);

  return (
    <div ref={containerRef} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        onClick={() => setShow(!show)}
        style={{
          width: 38, height: 38, border: "none", background: "transparent",
          cursor: "pointer", borderRadius: 10, padding: 0,
          display: "inline-flex", alignItems: "center", justifyContent: "center",
          fontSize: 16, lineHeight: 1,
          color: "#6b7280", transition: "background 0.15s ease, color 0.15s ease",
        }}
        onMouseEnter={e => { e.currentTarget.style.background = "rgba(3,142,220,0.08)"; e.currentTarget.style.color = "#038edc"; }}
        onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "#6b7280"; }}
      >
        🤣
      </button>

      {show && (
        <div style={{
          position: "absolute", zIndex: 9999,
          right: 0, top: "calc(100% + 6px)",
          boxShadow: "0 8px 32px rgba(0,0,0,0.15)",
          borderRadius: 14, overflow: "hidden",
        }}>
          <Picker
            data={data}
            onEmojiSelect={(emoji) => { handleAddEmoji(emoji); setShow(false); }}
          />
        </div>
      )}
    </div>
  );
};

export default EmojiPicker;
